import { useFilters } from '@/platform/hooks/useFilters';
import {
    Container,
    Segment,
    SegmentContent,
    SegmentHeader,
    TabNav,
    TabNavItem,
} from '@/platform/ui';
import Navigation from '@/platform/views/Questionnaires/components/Navigation';
import QuestionnaireForm from '@/platform/views/Questionnaires/components/QuestionnaireForm';

export const navItems = [
    {
        value: 7,
        label: 'LKV 2026',
    },
    {
        value: 2,
        label: 'LKV 18-56 (niet meer actueel)',
    },
    {
        value: 3,
        label: 'LKV 56+ (niet meer actueel)',
    },
];

const CreateOrUpdateView = () => {
    const { filters, updateFilters } = useFilters(['questionnaire']);

    return (
        <Container>
            <Navigation />

            <Segment>
                <SegmentHeader
                    header='LKV vragenlijst instellingen'
                    subheader='Gebruik deze sectie om lkv vragen te definiëren die in vragenlijsten zullen verschijnen.'
                />
                <SegmentContent>
                    <TabNav label='Categorie'>
                        {navItems.map(navItem => (
                            <TabNavItem
                                key={navItem.value}
                                active={filters.type == navItem.value}
                                onClick={() =>
                                    updateFilters('type', navItem.value)
                                }
                            >
                                {navItem.label}
                            </TabNavItem>
                        ))}
                    </TabNav>
                </SegmentContent>
            </Segment>

            <QuestionnaireForm submitUrl='/services/lkv/questionnaires' />
        </Container>
    );
};

export default CreateOrUpdateView;
